export const en = {
    visitors: {
        list: {
            name: "Name",
            email: "Email",
            company: "Company",
            mobilePhone: "Mobile Phone",
        },
        alerts: {
            checkout: {
                title: "Check-out",
                success: {
                    title: "Check-out Successful",
                    text: "Entries successfully checked-out",
                },
                error: {
                    title: "Check-out Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Visitor",
                text: "Are you sure you want to edit <b>%{visitor}</b>",
                success: {
                    title: "Visitor Edited Successfully",
                    text: "<b>%{visitor}</b> was edited successfully",
                },
                error: {
                    title: "Visitor Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        form: {
            headers: {
                edit: "Edit Visitor",
                view: "View Visitor",
                lastVisits: "Last Visits"
            },
            name: {
                label: "Name",
            },
            email: {
                label: "Email",
            },
            company: {
                label: "Company",
            },
            mobilePhone: {
                label: "Mobile Phone",
            },
        },
        errors: {
            invalidEmail: "Invalid email format"
        },
        searchFields: {
            name: "Visitor",
            email: "Email",
            company: "Company",
        }
    }
};